import Servicos from "./Servicos";

export default function Registros() {
  return (
    <div data-testid="registros-page">
      <Servicos />
    </div>
  );
}
